import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Col, Row, Breadcrumb, Tabs, Spin, message } from 'antd';
import { getObservationByID } from '../data/FrostApi';
import InfoCard from '../components/environmental/InfoCard';
import PurityIndex from '../components/charts/PurityIndex';
import ReflectanceChart from '../components/charts/ReflectanceChart';
import PropertiesTable from '../components/environmental/PropertiesTable';
import FieldMap from '../components/map/FieldMap';

function ObservationResults() {
    const { observationID } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    console.log('test', observationID);


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await getObservationByID(observationID);
                if (response) {
                    setData(response);
                } else {
                    message.error("No data found for the given observation ID.");
                }
            } catch (error) {
                console.error("Error during data fetching:", error);
                message.error(error.message || "Failed to fetch data.");
            } finally {
                setLoading(false);
            }
        };

        if (observationID) {
            fetchData();
        } else {
            message.error("Observation ID is not provided.");
        }

        // Clean up loading state if component unmounts
        return () => setLoading(false);
    }, [observationID]);


    const fetchPurityIndexData = async () => {
        const purityIndex = data?.result?.purityIndex;
        if (typeof purityIndex !== 'number') return [];

        return [
            ['Purity Index', purityIndex],
            ['Impurity Index', 100 - purityIndex],
        ];
    };


    const tabs = [
        {
            key: "1",
            label: "Info",
            children: (
                <>
                    <Row gutter={[16, 24]} style={{ marginTop: "30px" }}>
                        <Col span={12} xs={24} xl={12}>
                            <div style={{ marginBottom: "30px" }}>
                                <InfoCard data={data} title={'Observation Information'}/>
                            </div>
                        </Col>
                        <Col span={12} xs={24} xl={12}>  
                            {data?.result?.purityIndex != null &&
                                <div style={{ marginBottom: "30px" }}>
                                    <PurityIndex dataFetcher={fetchPurityIndexData} />
                                </div>
                            }

                            {data?.result?.soilProperties &&
                                <div style={{ marginBottom: "30px" }}>
                                    <PropertiesTable data={data?.result?.soilProperties} title={'Soil Properties'} />
                                </div>
                            }
                 
                        </Col>
                    </Row>
                </>
            ),
        },
        {
            key: "2",
            label: "Features of Interests",
            children: (
                <>          
                    <Row gutter={[16, 24]} style={{ marginTop: "30px" }}>
                        <Col span={12} xs={24} xl={12}>                           
                            <div style={{ marginBottom: "30px" }}>
                                <PropertiesTable data={data?.FeatureOfInterest?.properties} title={'Properties'} />
                            </div>
                            {data?.FeatureOfInterest?.Observations?.[1]?.result?.sample?.reflectance &&                
                                <ReflectanceChart data={data.FeatureOfInterest.Observations[1].result.sample.reflectance}/>
                            }                  

                        </Col>                    
                        <Col span={12} xs={24} xl={12}> 
                            <FieldMap data={data?.FeatureOfInterest?.feature?.geometry} />
                        </Col>
                    </Row>
                </>
            ),
        },
    ];

    return (
        <>
            <Spin spinning={loading} size="large">
                <div className="breadcrumb" style={{ textAlign: 'left', marginBottom: '50px' }}>
                    <h1 style={{ color: '#102F10' }}>
                        <Breadcrumb
                            items={[
                                {
                                    title: <a href="/">Home</a>,
                                },
                                {
                                    title: 'Datastream',
                                },
                                {
                                    title: <a href={`/environmental-monitoring-results/${data?.Datastream?.['@iot.id']}`}>{data?.Datastream['name']}</a>,
                                },
                                {
                                    title: 'Observation',
                                },
                                {
                                    title: data?.parameters?.foiId || data?.parameters?.name
                                },
                            ]}
                        />
                    </h1>
                </div>

                <Row gutter={[32, 24]}>
                    <Col xs={24}>
                        <Tabs defaultActiveKey="1" items={tabs} />
                    </Col>                  
                </Row> 
            </Spin>           
        </>
    );
}

export default ObservationResults;